// 重试保留同一动作编号，成功后才允许下一次独立操作。
export function createFriendWheelActions(api, providedStorage) {
  let storage = providedStorage;
  if (!storage) { try { storage = globalThis.sessionStorage; } catch { storage = null; } }
  const pending = new Map();
  function requestNo(key) {
    let previous = pending.get(key);
    try { previous ||= storage?.getItem(key); } catch { /* 使用当前会话内存 */ }
    if (previous) return previous;
    if (!globalThis.crypto?.getRandomValues) throw new Error('当前环境不支持安全操作编号');
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    const value = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    pending.set(key, value);
    try { storage?.setItem(key, value); } catch { /* 使用当前会话内存 */ }
    return value;
  }
  return async (action, id, username, targetUsername = '', walletCode = '') => {
    const targetKey = action === 'assist' ? targetUsername : '';
    const walletKey = action === 'withdraw' ? walletCode : '';
    const key = `friendWheel:${id}:${username}:${action}:${targetKey}:${walletKey}`;
    const result = await api[action](id, { requestNo: requestNo(key), ...(action === 'assist' ? { targetUsername } : {}), ...(action === 'withdraw' ? { walletCode } : {}) });
    if (!result?.status || result.memberUsername !== (action === 'assist' ? targetUsername : username)) throw new Error('未确认操作结果，请刷新后重试');
    pending.delete(key);
    try { storage?.removeItem(key); } catch { /* 后端仍按操作编号防重 */ }
    return result;
  };
}
